// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------
export function SetCostToTwoDecimalPlaces(cost: number, currency?: string) {
    let parsedCost = cost;
    if (typeof cost === 'string') {
        parsedCost = parseFloat(cost);
    }
    const formattedCost = (typeof parsedCost === 'number') ? (parsedCost).toFixed(2) : '---';
    return currency ? `${formattedCost} ${currency}` : formattedCost;
}

export function SetItemCostToTwoDecimalPlaces(item: { cost: number }, currency?: string) {
    return item ? SetCostToTwoDecimalPlaces(item.cost) : '---';
}
